module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Profile_01-6031f47d6f82081cb468182e8b5f36c6.jpg";